import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop"
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import { useShareEvaluatorSurvey } from "./useShareEvaluatorSurvey";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useShareDirectSurvey = ({ surveyData }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const fromDirectRes = true;
    const overlayRef = useRef(null);
    const { getSurveySessionSlots, rowData, deleteSession, options, extend, setExtend, editingRows, setEditingRows, handleSaveExtendTime, endDateEditor } = useShareEvaluatorSurvey({ surveyData, fromDirectRes });
    const [opts, setOptions] = useState({ users: [], session_status: [] });
    const [surveyQuestions, setSurveyQuestions] = useState({ list: [], selected: [] });
    const [loader, setLoader] = useState({ btn: false, grid: false });
    const [fieldValues, setFieldValues] = useState({ users: [], start_datetime: null, start_time: null, end_datetime: null, end_time: null, confirmation: false, delete_data: {}, survey_status: { survey_session_status_name: "All", survey_session_status_key: "all" } });
    const columns = [
        {
            field: "user_display_name",
            header: "User",
            width: "30%"
        },
        {
            field: "start_datetime",
            header: "Start Date",
            width: "25%"
        },
        {
            field: "end_datetime",
            header: "End Date",
            width: "25%"
        },
        {
            field: "survey_session_status",
            header: "Status",
            width: "10%"
        },
        // {
        //     field: "delete",
        //     header: "Action",
        //     width: "5%"
        // },
    ]

    useEffect(() => {
        callautopopulate("users", "control_center_user_category", "projects", "technology", "user_status", "units", "role_on_project")?.then(res => {
            const roles = _.uniq(_.pluck(res?.role_on_project, "role_on_project"))
            setOptions((prev) => ({
                ...prev,
                all_users: _.sortBy(res?.users, "user_display_name"),
                users: _.sortBy(res?.users, "user_display_name"),
                category: _.sortBy(res?.control_center_user_category, "user_category_name"),
                projects: _.sortBy(res?.projects, "project_name"),
                technology: _.sortBy(res?.technology, "technology_name"),
                user_status: _.sortBy(res?.user_status, "user_status"),
                units: _.sortBy(res?.day_calendar_groups, "group_name"),
                roles: _.sortBy(roles),
            }));
        })

        let questions = [];
        const sortedCategory = _.sortBy(surveyData?.survey_question_details, "category_order_number");
        _.filter(sortedCategory, quest => quest?.category_order_number > 0)?.concat(_.filter(sortedCategory, quest => quest?.category_order_number === 0))?.forEach((item) => {
            if (_.isEmpty(_.findWhere(questions, { category: item?.question_category_key }))) {
                const questList = _.sortBy(_.filter(surveyData?.survey_question_details, ques => ques?.question_category_key === item?.question_category_key), "question_order_number");
                const combinedQuest = _.filter(questList, quest => quest?.question_order_number > 0)?.concat(_.filter(questList, quest => quest?.question_order_number === 0))
                questions.push({
                    category: item?.question_category_key,
                    id: item?.question_category_id,
                    name: item?.question_category_name,
                    questions: _.uniq(combinedQuest, "question_id")
                })
            }
        })

        let selected = {};
        let category = {};
        surveyData?.survey_question_details?.forEach(item => {
            selected[item?.question_id] = { question_id: item?.question_id, question_order_number: item?.question_order_number };
            if (!category[item?.question_category_id]) {
                category[item?.question_category_id] = { question_category_id: item?.question_category_id, category_order_number: item?.category_order_number }
            }
        })
        setSurveyQuestions((prev) => ({ ...prev, list: questions, selected: { questions: selected, category: category } }));
    }, [])

    useEffect(() => {
        callGetSession();
    }, [fieldValues?.survey_status])

    useEffect(() => {
        setOptions((prev) => ({ ...prev, session_status: options?.session_status, roles: options?.roles, leads: options?.leads }));
    }, [options])

    useEffect(() => {
        handleFilterChange();
    }, [options?.user_wise_roles, opts?.all_users, fieldValues?.leads, fieldValues?.roles, fieldValues?.category, fieldValues?.units, fieldValues?.projects, fieldValues?.technology, fieldValues?.status, rowData?.session_slot])

    const callGetSession = async () => {
        setLoader((prev) => ({ ...prev, grid: true }));
        await getSurveySessionSlots(fieldValues?.survey_status?.survey_session_status_key === "all" ? null : fieldValues?.survey_status, fieldValues?.survey_status?.survey_session_status_key === "all");
        setLoader((prev) => ({ ...prev, grid: false }));
    }

    const generateSession = async () => {
        try {
            const startDate = `${dateConvert(fieldValues?.start_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(fieldValues?.start_time, "hour-min")}`;
            const endDate = `${dateConvert(fieldValues?.end_datetime, "iso-string")?.split("T")?.[0]}T${dateConvert(fieldValues?.end_time, "hour-min")}`;
            if (_.isEmpty(fieldValues?.users)) {
                showInfo("Info", "Please select atleast 1 user");
                return;
            } else if (!fieldValues?.start_datetime) {
                showInfo("Info", "Please select start date");
                return;
            } else if (!fieldValues?.start_time) {
                showInfo("Info", "Please select start time");
                return;
            } else if (!fieldValues?.end_datetime) {
                showInfo("Info", "Please select end date");
                return;
            } else if (!fieldValues?.end_time) {
                showInfo("Info", "Please select end time");
                return;
            } else if (new Date(startDate) < new Date() || new Date(startDate) < new Date(surveyData?.survey_details?.[0]?.start_datetime)) {
                showInfo("Info", "Session start date cannot be less than today/survey start date");
                return;
            } else if (new Date(startDate) >= new Date(surveyData?.survey_details?.[0]?.end_datetime)) {
                showInfo("Info", "Session start date cannot be greater than survey end date");
                return;
            } else if (new Date(endDate) > new Date(surveyData?.survey_details?.[0]?.end_datetime)) {
                showInfo("Info", "Session end date cannot be greater than survey end date");
                return;
            } else if (new Date(endDate) <= new Date(startDate)) {
                showInfo("Info", "Session end date cannot be less than or same as survey start date");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            const payload = {
                "survey_id": surveyData?.survey_details?.[0]?.survey_id,
                "session_user_codes": _.pluck(fieldValues?.users, "user_code")?.toString() || "",
                "question_ids": _.pluck(surveyQuestions?.selected?.questions, "question_id")?.toString() || "",
                "start_datetime": startDate || "",
                "end_datetime": endDate || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERSURVEYSESSION"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                getSurveySessionSlots(null, true);
                setFieldValues((prev) => ({ ...prev, users: [], start_datetime: null, end_datetime: null, start_time: null, end_time: null }));
                setLoader((prev) => ({ ...prev, btn: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, btn: false }));
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const handleEdit = (rowdata) => {
        const filteredUsers = handleFilterChange(true);
        const user = _.findWhere(opts?.all_users, { user_code: rowdata?.user_code }) || [];
        setFieldValues((prev) => ({ ...prev, users: [_.findWhere(opts?.all_users, { user_code: rowdata?.user_code })], start_datetime: new Date(rowdata?.start_datetime), start_time: new Date(rowdata?.start_datetime), end_datetime: new Date(rowdata?.end_datetime), end_time: new Date(rowdata?.end_datetime) }));
        if (!_.isEmpty(user)) {
            setOptions((prev) => ({ ...prev, users: [user, ...filteredUsers] }))
        }

    }

    const bodyTemplate = (rowdata, col, options) => {
        return (
            <div>{(col?.field === "start_datetime" || col?.field === "end_datetime") ? dateConvert(rowdata?.[col?.field], "date-time-months") :
                col === "delete" ?
                    <>
                        {options.rowEditor?.editing ?
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="c-pointer" onClick={(e) => options?.rowEditor?.onSaveClick(e)} style={{ fontSize: "0.85rem", width: "2rem", height: "auto" }}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /></div>
                                <div className="c-pointer" onClick={(e) => options?.rowEditor?.onCancelClick(e)} style={{ fontSize: "0.85rem", width: "2rem", height: "auto" }}><FontAwesomeIcon icon="fa-solid fa-close" /></div>
                            </div> :
                            <div className="d-flex justify-content-evenly align-items-center">
                                {
                                    rowdata?.survey_session_status === "scheduled" ? <div className={`c-pointer `} onClick={() => handleEdit(rowdata)}>
                                        <FontAwesomeIcon icon="fa-solid fa-edit" />
                                    </div> : <>
                                        {extend?.data?.length === 0 && <div {...options?.rowEditor?.element?.props} style={{ fontSize: "0.85rem", width: "2rem", height: "auto", visibility: rowdata?.survey_session_status !== "completed" ? "visible" : "hidden" }} title="Extend End Date"><FontAwesomeIcon icon="fa-solid fa-calendar" /></div>}
                                    </>
                                }
                                <div className={`text-danger c-pointer ${(rowdata?.survey_session_status === "expired" || rowdata?.survey_session_status === "scheduled") ? "visible" : "invisible"}`} onClick={() => setFieldValues((prev) => ({ ...prev, confirmation: true, delete_data: rowdata }))}>
                                    <FontAwesomeIcon icon="fa-solid fa-trash" />
                                </div>
                            </div>
                        }
                    </>
                    :
                    rowdata?.[col?.field]}
            </div>
        )
    }

    const listBoxFilterTemplate = (option) => {
        const allSelected = fieldValues?.users?.length > 0 && _.every(opts?.users, item => _.pluck(fieldValues?.users, "user_code")?.includes(item?.user_code));
        const handleSelectAll = (checked) => {
            setFieldValues((prev) => ({ ...prev, users: checked ? [...opts?.users] : [] }));
        };

        return (
            <div className="d-flex align-items-center gap-2 px-1">
                <input type="checkbox" checked={allSelected} onChange={(e) => handleSelectAll(e?.target?.checked)} />
                <div className='w95 border'>{option?.element}</div>
            </div>
        );
    };

    const listBoxOptionTemplate = (option) => {
        return (
            <div className="d-flex align-items-center gap-3">
                <input type='checkbox' checked={_.pluck(fieldValues?.users, "user_code")?.includes(option?.user_code)}
                    onChange={(e) => {
                        let dataArray = [...fieldValues?.users];
                        if (e.target?.checked) {
                            dataArray.push(option);
                        } else {
                            dataArray = _.filter(dataArray, item => item?.user_code !== option?.user_code);
                        }
                        setFieldValues((prev) => ({ ...prev, users: dataArray }));
                    }}
                />
                <div>{option?.user_display_name}</div>
            </div>
        );
    };

    const handleFilterChange = (returnValue) => {
        let filteredUsers = [];
        const rolesUserCode = _.pluck(_.filter(options?.user_wise_roles, item => fieldValues?.roles?.includes(item?.role_on_project)), "user_code");
        const leadsEmployeeId = _.pluck(fieldValues?.leads, "employee_id");
        const categoryId = _.pluck(fieldValues?.category, "user_category_id");
        filteredUsers = _.filter(opts?.all_users, item => {
            const rolesFlag = _.isEmpty(rolesUserCode) ? true : rolesUserCode?.includes(item?.user_code);
            const leadsFlag = _.isEmpty(leadsEmployeeId) ? true : leadsEmployeeId?.includes(item?.reporting_employee_id);
            const categoryFlag = _.isEmpty(categoryId) ? true : categoryId?.includes(item?.user_category_id);
            return rolesFlag && leadsFlag && categoryFlag;
        })

        if (!_.isEmpty(rowData?.session_slot)) {
            filteredUsers = _.filter(filteredUsers, item => !_.pluck(rowData?.session_slot, "user_code")?.includes(item?.user_code));
        }
        setOptions((prev) => ({ ...prev, users: filteredUsers }));

        if (!_.isEmpty(fieldValues?.users) && !returnValue) {
            const users = _.filter(fieldValues?.users, item => _.pluck(filteredUsers, "user_code")?.includes(item?.user_code));
            setFieldValues((prev) => ({ ...prev, users }))
        }
        if (!_.isEmpty(fieldValues?.projects)) {
            filteredUsers = _.filter(filteredUsers, item => _.pluck(fieldValues?.projects, "project_id")?.includes(item?.primary_project_id))
        }
        if (!_.isEmpty(fieldValues?.technology) && filteredUsers?.[0]?.technology) {
            filteredUsers = _.filter(filteredUsers, item => { return _.pluck(fieldValues?.technology, "technology_name")?.includes(item?.technology) })
        }
        if (!_.isEmpty(fieldValues?.status) && filteredUsers?.[0]?.user_status_id) {
            filteredUsers = _.filter(filteredUsers, item => _.pluck(fieldValues?.status, "user_status_id")?.includes(item?.user_status_id))
        }
        if (!_.isEmpty(fieldValues?.units)) {
            filteredUsers = _.filter(filteredUsers, item => _.pluck(fieldValues?.units, "group_id")?.includes(item?.group_id))
        }

        if (returnValue) return filteredUsers;
    }


    return useMemo(() => ({
        surveyQuestions, fieldValues, setFieldValues, opts, generateSession, columns, rowData, deleteSession, loader, bodyTemplate, callGetSession, listBoxFilterTemplate, listBoxOptionTemplate, overlayRef, handleFilterChange, endDateEditor, extend, setExtend, editingRows, setEditingRows, handleSaveExtendTime, getSurveySessionSlots
    }), [surveyQuestions, fieldValues, setFieldValues, opts, generateSession, columns, rowData, deleteSession, loader, bodyTemplate, callGetSession, listBoxFilterTemplate, listBoxOptionTemplate, overlayRef, handleFilterChange, endDateEditor, extend, setExtend, editingRows, setEditingRows, handleSaveExtendTime,])
}